export default __webpack_public_path__ + "a3af239272944c20338f76ca37e08745.svg";